<template>
	<div>
		<v-btn color="success"
			@click="addProjectVisible = true"
		>
			<v-icon class="mr-2 white--text">add</v-icon>
			Rozpocznij składanie nowego wniosku
		</v-btn>
		<v-dialog
			v-model="addProjectVisible"
			max-width="1000px"
		>
			<v-card>
				<v-toolbar>
					<v-toolbar-title>Składanie nowego wniosku</v-toolbar-title>
				</v-toolbar>
				<v-form ref="form" class="ma-3">
					<v-layout row>
						<v-flex xs1/>
						<v-flex xs10>
							<egranty-text-input-field
								v-model="projectName"
								label="Nazwa wniosku"
								name="projectName"
								for="add-project-popup-project-name"
								id="add-project-popup-project-name"/>
						</v-flex>
						<v-flex xs1/>
					</v-layout>
					<v-layout row>
						<v-flex xs1/>
						<v-flex xs10>
							<egranty-text-input-field
								v-model="englishProjectName"
								label="Angielska nazwa wniosku"
								name="englishProjectName"
								for="add-project-popup-english-project-name"
								id="add-project-popup-english-project-name"/>
						</v-flex>
						<v-flex xs1/>
					</v-layout>
				</v-form>
				<v-layout row>
					<v-spacer/>
					<v-btn class="add-project-popup-btn" @click="send">
						Zapisz i rozpocznij wypełnianie
					</v-btn>
				</v-layout>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import EgrantyTextInputField from "../../../genericComponents/EgrantyTextInputField";
	import {AgencyProject} from "@/api/generated/AgencyProject";

	export default {
		name: "AddProjectPopup",

		components: {EgrantyTextInputField},

		methods: {
			send() {
				if (!this.$refs.form.validate()) {
					return;
				}
				let projectData = {};
				projectData.contestId = this.contestData.id;
				projectData.title = this.projectName;
				projectData.englishTitle = this.englishProjectName;

				AgencyProject.post(
					this,
					projectData,
					response => {
						this.$router.push("/app/agency-contest/" + this.contestData.id + "/project/" + response);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message);
					}
				);
			},
		},

		data() {
			return {
				contestData: {
					id: this.$route.params.id,
				},
				addProjectVisible: false,
				projectName: "",
				englishProjectName: "",
				error: "",
			};
		},
	};
</script>

<style scoped>
  .add-project-popup-btn {
    background-color: #f5f5f5;
    margin-left: 20px;
    margin-right: 60px;
    margin-bottom: 20px;
  }
</style>
